import { render, staticRenderFns } from "./setInquiry.vue?vue&type=template&id=1f725b95&scoped=true"
import script from "./setInquiry.vue?vue&type=script&lang=ts"
export * from "./setInquiry.vue?vue&type=script&lang=ts"
import style0 from "./setInquiry.vue?vue&type=style&index=0&id=1f725b95&prod&lang=scss&scoped=true"
import style1 from "./setInquiry.vue?vue&type=style&index=1&id=1f725b95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f725b95",
  null
  
)

export default component.exports